import { render, staticRenderFns } from "./updateSub.vue?vue&type=template&id=17d2c230&scoped=true&"
import script from "./updateSub.vue?vue&type=script&lang=js&"
export * from "./updateSub.vue?vue&type=script&lang=js&"
import style0 from "./updateSub.vue?vue&type=style&index=0&id=17d2c230&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d2c230",
  null
  
)

export default component.exports